import {Component, Input, OnInit} from '@angular/core';
import {map, takeWhile, timer} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {ConfigService} from '@shared-library';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-vault-signin-code',
    templateUrl: './vault-signin-code.component.html',
    styleUrls: ['./vault-signin-code.component.css'],
    standalone: false
})
export class VaultSigninCodeComponent implements OnInit {
  loading: boolean = false
  resendingCode: boolean = false
  errorMsg: string = ""

  @Input() currentEmail = "test@example.com"

  codeExpirySeconds = 300;
  timeRemaining$ = this.createCountdown();


  constructor(
    private routerService: Router,
    private authService: AuthService,
    private configService: ConfigService,
  ) {}

  ngOnInit(): void {
  }

  onResendCode(){
    if (!this.currentEmail) {
      this.errorMsg = "email is required to resend the code"
      return
    }

    this.resendingCode = true
    this.errorMsg = ""

    this.authService.VaultAuthBegin(this.currentEmail, environment.csp_prompt_force)
      .then(() => {
        this.resendingCode = false
        this.timeRemaining$ = this.createCountdown()
      })
      .catch(() => {
        this.resendingCode = false
        this.errorMsg = "unable to resend code"
      })
  }

  onCodeCompleted(code: string){
    this.loading = true

    console.log("submit finish", this.currentEmail, code)
    this.authService.VaultAuthFinish(this.currentEmail, code)
      .then((resp) => {
        this.loading = false
        if(resp?.has_verified_identity && resp?.verified_identity_csp_type){
          this.configService.vaultProfileConfig = {
            verifiedIdentityCspType: resp.verified_identity_csp_type,
            verifiedIdentityPatientDemographics: resp.verified_identity_patient_demographics
          }
        }

        const nextPath = resp?.has_verified_identity ? 'dashboard' : '/auth/identity/verification'
        this.routerService.navigateByUrl(nextPath)
      })
      .catch((err)=>{
        console.error(err)
        this.loading = false
        if(err?.name){
          this.errorMsg = "code is incorrect"
        } else{
          this.errorMsg = "an unknown error occurred during sign-in"
        }
      })
  }

  private createCountdown() {
    return timer(0, 1000).pipe(
      map(n => (this.codeExpirySeconds - n) * 1000),
      takeWhile(n => n >= 0),
    );
  }

}
